export { default, meta } from "./routes/_index.tsx";